export const IconGrayPlusAdd: {
  name: 'icon_gray_plus_add-1154a2a765d7'
} = {
  name: 'icon_gray_plus_add-1154a2a765d7'
}
